import ReactDOM from 'react-dom'
import App from '@components/locations'
import { AppProvider } from '@components/locations/Context'

const rootNode = document.getElementById('locations-app')

const fn = {
  init: () => {
    const data = JSON.parse(rootNode.dataset.json)
    const endpoint = rootNode.dataset.endpoint

    ReactDOM.render(
      <AppProvider>
        <App data={data} endpoint={endpoint} />
      </AppProvider>,
      rootNode
    )
  },
}

export default {
  can: () => rootNode,
  run: fn.init,
}
